import type { PlanId } from './types'

export const PLAN_ORDER: PlanId[] = ['free', 'pro', 'team', 'enterprise']

export const PLAN_NAMES: Record<PlanId, string> = {
  free: 'Free',
  pro: 'Pro',
  team: 'Team',
  enterprise: 'Enterprise'
}

export const CHECKOUT_POLL_INTERVAL_MS = 2_000
export const CHECKOUT_POLL_TIMEOUT_MS = 60_000

export enum BillingErrorCodes {
  PaymentRequired = 402,
  Conflict = 409
}
